export default __webpack_public_path__ + "bb14dc80e8b5d860fe9cb2362987d630.ttf";